export default "__VITE_ASSET__187a08cf__"